<template>
  <div class="MagazineList w-full">
    <div class="w-full" v-if="MagData">
      <Breadcrumb />
      <div class="item" v-for="(item, index) in MagData" :key="index">

          <div class="flex md:items-center cover flex-wrap">
            <div class="w-1/3 lg:w-3/12 xl:w-1/5 px-3" v-if="item.cover && item.isLoaded">
              <img :src="item.cover" :alt="item.title">
            </div>
            <div class="w-1/3 lg:w-3/12 xl:w-1/5 px-3" v-else>
              <vue-content-loading :width="250" :height="320">
                <rect cx="30" cy="30" width="250" r="30" height="320" x="15" y="0" />
              </vue-content-loading>
            </div>
            <div class="w-2/3 lg:w-6/12 xl:w-2/5 lg:px-3 rounded-b lg:rounded-b-none lg:rounded-r flex flex-col justify-center leading-normal">
              <div class="listTitle flex items-start md:items-center flex-wrap md:flex-no-wrap">
                <div class="magazineLogo mr-2 mb-2">
                  <img class="w-full h-full object-contain block" :src="item.logo" alt="livaABC">
                </div>
                <div class="flex flex-no-wrap items-center">
                  <div class="hashtag md:mx-2 mb-2 text-sm md:text-base">
                    <div class="level bg-gray-800 text-white px-3 rounded-full" style="padding-top: 2px;">
                      <h4 class="mb-0 font-bold whitespace-no-wrap">{{ item.leval }}</h4>
                    </div>
                  </div>
                  <div class="title ml-1 md:ml-2 mb-2 text-sm md:text-base">
                    <h4 class="mb-0 whitespace-no-wrap">{{ item.range }}</h4>
                  </div>
                </div>
              </div>
              <div class="listContent max-w-lg text-sm md:text-base">
                <div class="degree flex flex-col sm:flex-row md:flex-no-wrap" v-if="item.applicability !== ''">
                  <div class="title-content whitespace-pre-wrap text-sm">
                    <h6 class="mb-1 md:mb-0">適用程度：{{ item.applicability }}</h6>
                  </div>
                </div>
                <div class="target flex flex-col sm:flex-row md:flex-no-wrap" v-if="item.suitable !== ''">
                  <div class="title-content whitespace-pre-wrap text-sm">
                    <h6 class="mb-1 md:mb-0">學習目標：{{ item.suitable }}</h6>
                  </div>
                </div>
                <ul class="list-inside mt-2 text-sm hidden md:block">
                  <li v-for="(child) in item.detail" :key="child.text" :class="`${child.className}`">{{ child.text }}</li>
                </ul>
              </div>
            </div>
            <div class="w-full lg:w-3/12 xl:w-2/5 mt-4 lg:mt-0 px-3 leading-normal flex flex-wrap item-center">
              <div class="w-1/2 md:w-1/4 lg:w-full xl:w-1/2 p-1 xl:p-2"><a class="block magBtn uppercase text-center xl:px-8 py-2 border borderLivePink textColorPink hover:text-white cursor-pointer" @click="btnLink(item.category_id, 4)">雜誌訂閱</a></div>
              <!-- <div class="w-1/2 md:w-1/4 lg:w-full xl:w-1/2 p-1 xl:p-2"><a class="block magBtn uppercase text-center xl:px-8 py-2 border borderLivePink textColorPink hover:text-white cursor-pointer" @click="btnLink(item.category_id, 0)">雜誌新訂</a></div>
              <div class="w-1/2 md:w-1/4 lg:w-full xl:w-1/2 p-1 xl:p-2"><a class="block magBtn uppercase text-center xl:px-8 py-2 border borderLivePink textColorPink hover:text-white cursor-pointer" @click="btnLink(item.category_id, 1)">雜誌續訂</a></div> -->
              <div class="w-1/2 md:w-1/4 lg:w-full xl:w-1/2 p-1 xl:p-2"><a class="block magBtn uppercase text-center xl:px-8 py-2 border borderLivePink textColorPink hover:text-white cursor-pointer" @click="btnLink(item.category_id, 2)">紙本零售</a></div>
              <div class="w-1/2 md:w-1/4 lg:w-full xl:w-1/2 p-1 xl:p-2" v-if="item.category !== 'HOW IT WORKS'"><a class="block magBtn uppercase text-center xl:px-8 py-2 border borderLivePink textColorPink hover:text-white cursor-pointer" @click="btnLink(item.digital_id, 3)">軟體零售</a></div>
              <div class="w-full p-1 xl:p-2"><router-link :to="{ name: 'magazineIntro', params: { class: item.intro } }" class="block magBtn uppercase text-center xl:px-8 py-2 border borderLivePink text-white bg-live-pink  hover:text-white cursor-pointer">雜誌介紹</router-link></div>
            </div>
          </div>
          <hr class="my-5 border-t borderColorgray">
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import VueContentLoading from 'vue-content-loading'
import Breadcrumb from '@/components/product/Breadcrumb'
export default {
  name: 'CurrentMagazine',
  metaInfo () {
    return {
      title: '雜誌館'
    }
  },
  data () {
    return {
      MagData: [
        {
          category_id: 123,
          digital_id: 154,
          logo: require('@/assets/logo/logo_abc.png'),
          title: 'ABC互動英語',
          category: 'ABC互動英語',
          leval: '初級',
          range: '基礎、活用',
          applicability: '全民英檢初級',
          suitable: '國中小學生～成人，英語初學者',
          detail: [
            { text: '數位智能互動，搭配AI口說、寫作批改功能', className: 'font-semibold' },
            { text: '打好英語基礎的最佳選擇', className: '' },
            { text: '活潑、實用、有趣的豐富內容，學英語不再痛苦', className: '' },
            { text: '情境教學，學英語像學母語一樣自然', className: '' }
          ],
          isLoaded: false,
          intro: 'ABC'
        },
        {
          category_id: 124,
          digital_id: 160,
          logo: require('@/assets/logo/logo_live.png'),
          title: 'Live互動英語',
          category: 'Live互動英語',
          leval: '中級',
          range: '生活、實用',
          applicability: '全民英檢中級',
          suitable: '國高中生～成人，一般生活英語會話',
          detail: [
            { text: '數位智能互動，搭配AI口說、寫作批改功能', className: 'font-semibold' },
            { text: '教材貼近日常生活，實用英語輕鬆學', className: '' },
            { text: '真人實景拍攝課程影片，開口說不再困難', className: '' },
            { text: '情境式會話，體驗如在國外學英語的驚人效果', className: '' }
          ],
          isLoaded: false,
          intro: 'LIVE'
        },
        {
          category_id: 125,
          digital_id: 161,
          logo: require('@/assets/logo/logo_all.png'),
          title: 'ALL+互動英語',
          category: 'ALL+互動英語',
          leval: '中高級',
          range: '進階、應用',
          applicability: '進階英語學習',
          suitable: '具基礎能力，想要英語再升級的高中生～成人',
          detail: [
            { text: '數位智能互動，搭配AI口說、寫作批改功能', className: 'font-semibold' },
            { text: '深度教學內容，題材豐富多元，讓您的英語上的了檯面', className: '' },
            { text: '大量精選閱讀文章，讓您開始用英語思考', className: '' },
            { text: '主題式寫作訓練，掌握關鍵學習技巧', className: '' }
          ],
          isLoaded: false,
          intro: 'ALL'
        },
        {
          category_id: 126,
          digital_id: 162,
          logo: require('@/assets/logo/logo_cnn.png'),
          title: 'CNN互動英語',
          category: 'CNN互動英語',
          leval: '新聞',
          range: '時事、新知',
          applicability: '專業新聞英語學習',
          suitable: '準備出國或生活中需要大量使用英語溝通者',
          detail: [
            { text: '數位智能互動，搭配AI口說功能', className: 'font-semibold' },
            { text: 'CNN官方授權，LiveABC傾力製作', className: '' },
            { text: '最多大專院校老師推薦的聽力訓練素材', className: '' },
            { text: '學好英語邁向國際化，最道地的英語教材', className: '' }
          ],
          isLoaded: false,
          intro: 'CNN'
        },
        {
          category_id: 122,
          digital_id: 163,
          logo: require('@/assets/logo/logo_jp.png'),
          title: '互動日本語',
          category: '互動日本語',
          leval: '初級',
          range: '生活、實用',
          applicability: '基礎～初中級',
          suitable: '具備一般日語閱讀能力，適用JLPT測驗N5-N3檢定',
          detail: [
            { text: '數位智能互動，搭配AI口說功能', className: 'font-semibold' },
            { text: '專業日籍老師主編，學習內容實用到位', className: '' },
            { text: '主題包含日劇、動漫、旅遊、文化等，越學越有趣', className: '' },
            { text: '每月附日檢JLPT模擬考題，訓練應考能力', className: '' }
          ],
          isLoaded: false,
          intro: 'JPN'
        },
        {
          category_id: 121,
          digital_id: 121,
          logo: require('@/assets/logo/logo_hiw.png'),
          title: 'HIW知識大圖解',
          category: 'HOW IT WORKS',
          leval: '科普',
          range: '圖像、百科',
          applicability: '',
          suitable: '',
          detail: [
            { text: 'How It Works以圖像化百科呈現，精彩易懂活潑有趣', className: '' },
            { text: '由世界公認、首屈一指的科普專家編製', className: '' },
            { text: '內容深入淺出，適合各年齡層讀者', className: '' },
            { text: '主題豐富多元，永遠滿足讀者的好奇心', className: '' },
            { text: '高品質圖解，提供最愉悅的閱讀體驗', className: '' }
          ],
          isLoaded: false,
          intro: 'HIW'
        }
      ]
    }
  },
  components: {
    Breadcrumb,
    VueContentLoading
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      let self = this

      await axios.get('/newest-magazines/')
        .then((response) => {
          response.data.map(item1 => {
            self.MagData.map(item2 => {
              if (item1.category_id === item2.category_id) {
                return Object.assign(item1, item2)
              }
            })
          })
          self.MagData = response.data
        })
        .then(() => {
          self.onImageLoaded()
        })
    },
    btnLink (id, num) {
      let self = this
      let queryObj = {}

      if (num === 0) {
        queryObj.type = 'PLAN'
        queryObj.scope = 'new_magazine_plan'
      } else if (num === 1) {
        queryObj.type = 'PLAN'
        queryObj.scope = 'discount_magazine_plan'
      } else if (num === 2) {
        queryObj.type = 'MAGAZINE,PHYSICAL'
      } else if (num === 3) {
        queryObj.type = 'MAGAZINE,DIGITAL'
      } else if (num === 4) {
        queryObj.type = 'PLAN'
        queryObj.scope = 'magazine_plan'
      }

      queryObj.category = id
      self.$router.push({ name: 'productsList', params: { category: 'magazine' }, query: queryObj })
    },
    onImageLoaded () {
      let self = this
      self.isLoaded = false
      for (let item of self.MagData) {
        var image = new Image()
        image.src = item.cover

        if (image.complete) {
          item.isLoaded = true
        } else {
          image.onload = () => {
            item.isLoaded = true
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .MagazineList {
    min-height: calc(100vh - 125px);
    .cover {
      img {
        object-fit: contain;
      }
    }
    .listTitle {
      .magazineLogo {
        img {
          max-width: 160px;
        }
      }
      .hashtag {
        font-weight: 700;
        font-family: 'NotoSansTC-Bold';
        h4 {
          line-height: 2em;
        }
      }
      .title {
        font-weight: 700;
        font-family: 'NotoSansTC-Bold';
        h4 {
          line-height: 2em;
        }
      }
    }
    .listContent {
      .degree, .target {
        .title-content {
          font-family: 'NotoSansTC-Bold';
          font-weight: 700;
          color: #434343;
          line-height: 22px;
        }
      }
      ul {
        li {
          font-weight: 400;
          color: #434343;
          line-height: 20px;
        }
        li:before {
            content: "";
            display: inline-block;
            width: 3px;
            height: 3px;
            background-color: #C8C7C2;
            border-radius: 50%;
            margin-right: .4rem;
            vertical-align: middle;
        }
      }
    }
    hr {
      border-top-color: #504f4f;
    }
    .magBtn {
      &:hover {
        background-color: #EF5559;
      }
    }
  }
</style>
